import { FormFieldset, FormGrid, InputField } from '@app/components/various/Form';
import { getIsStockTypeSeparationEnabled } from '@app/ducks';
import { Settings } from '@typings';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  isDisabled: boolean;
  isLoading: boolean;
}

export const CustomTextsFields = ({ isDisabled, isLoading }: Props) => {
  const { t } = useTranslation(['common', 'settings', 'translations']);
  const isStockSeparationEnabled = useSelector(getIsStockTypeSeparationEnabled);
  const { register } = useFormContext<Settings.CustomisationFormFields>();

  return (
    <section className="box space-y-5">
      <h3 className="heading-3">{t('settings:custom_text')}</h3>
      <p className="text-neutral-40 body-2">{t('settings:custom_text_subtitle')}</p>
      <FormFieldset isDisabled={isDisabled}>
        <FormGrid rowGap="xlarge">
          <InputField
            placeholder={t('common:login_page_message')}
            label={t('common:login_page_message')}
            helpMessage={t('settings:login_page_description')}
            isLoading={isLoading}
            {...register('loginPageMessage')}
          />
          <InputField
            placeholder={t('common:sold_out')}
            label={t('translations:sold_out_label')}
            helpMessage={t('settings:sold_out_label_description')}
            isLoading={isLoading}
            {...register('soldOutLabel')}
          />
          {isStockSeparationEnabled && (
            <>
              <InputField
                placeholder={t('common:stock')}
                label={t('translations:stock_filter_name')}
                helpMessage={t('settings:filter_label_description')}
                isLoading={isLoading}
                {...register('stockTypeLabel')}
              />
              <InputField
                placeholder={t('common:preorder')}
                label={t('translations:preorder_filter_name')}
                helpMessage={t('settings:filter_label_description')}
                isLoading={isLoading}
                {...register('preorderStockTypeLabel')}
              />
            </>
          )}
        </FormGrid>
      </FormFieldset>
    </section>
  );
};
